export const SURVEY_CONSTANT = {
  SURVEY_TITLE: `Pulse Survey's`,
  SURVEY_HEADING_1: `Prioritize mental health with Shoorah Business pulse surveys.`,
  SURVEY_HEADING_2: `Create custom pulse surveys, gain insights, and support your team's wellbeing like never before.`,
  NEW_SURVEY_CREATE_HEADING: `Create a New Pulse Survey`,
  NEW_SURVEY_CREATE: `Create New`,
  VIEW_ALL_TEMPLATE: `View All Template`,
  MY_SURVEY_LIST_BUTTON: `My Pulse Survey's`,
  SURVEY_VIEW_DRAFTS_BUTTON: `View Drafts`,
  SURVEY_INSIGHTS_HEADER: `Insights`,
  SURVEY_DID_YOU_KNOW_TEXT: `Did you know that UK businesses that regularly conduct employee engagement pulse surveys are 2.5 times more likely to have employees who feel motivated and satisfied at work ?`,
  SURVEY_EXPLORE_TEMPS: `Explore our templates`,
  SURVEY_SIDEBAR_NAME: `Pulse Survey`,
  MY_SURVEY_LIST_HEADER: `My Pulse Survey's`,
  MY_SURVEY_LIST_TABLE_NAME_HEADER: `Pulse Survey Name`,
  MY_SURVEY_LIST_TAB: `Pulse Survey Name`,
  NEW_SURVEY_CREATE_HEADER_1: `My Pulse Survey`,
  NEW_SURVEY_CREATE_HEADER_2: `Create Pulse Survey`,
  SURVEY_INPUT_TITLE: `Pulse Survey Title`,
  SURVEY_INPUT_CATEGORY: `Pulse Survey Category`,
  NEW_SURVEY_BUTTON_DRAFT: `SAVE AS DRAFT`,
  MODIFY_TEMPLATE: `MODIFY TEMPLATE`,
  MODIFY_SURVEY: `MODIFY SURVEY`,
  CREATE_SURVEY: `CREATE SURVEY`,
  NEW_SURVEY_BUTTON_TEMPLATE: `SAVE AS TEMPLATE`,
  NEW_SURVEY_BUTTON_NEXT: `NEXT`,
  NEW_SURVEY_BUTTON_SAVE_SURVEY: `SAVE AS PULSE SURVEY`,
  NEW_SURVEY_BULK_BUTTON_HEADER_1: `Your existing answer choices are not displayed because only limited changes are allowed for this question.`,
  NEW_SURVEY_BULK_BUTTON_HEADER_2: `Any new answer choices you add below will be appended to your existing answer choices.`,
  NEW_SURVEY_CATEGORY_ADD: `Add New Category`,
  NEW_SURVEY_CATEGORY_NAME: `Pulse Survey Category Name`,
  SURVEY_PREVIEW_TITLE: `Preview and Submit`,
  REVIEW_SURVEY_TITLE: `Review Pulse Survey`,
  NEW_SURVEY_DURATION_TITLE: `Select Pulse Survey Duration`,
  NEW_SURVEY_CREATE_SUCCESS: `New pulse survey created successfully`,
  SURVEY_STATS_HEADER: `Pulse Survey Statistics`,
  TEMPLATE_CREATED_FOR_SUBADMIN: `Template created and sent for approval successfully`,
  TEMPLATE_FOR_ADMIN: 'Template created successfully',
  NOTIFY_TIME: 'Notify Time',
  SCOPE: 'Scope',
  TARGET: 'Target',
  SELF_ASSESSMENT: 'Self Assessment'
};
